/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Compax Frontend API-v2
 * API by Compax
 * OpenAPI spec version: 161.0.0-SNAPSHOT
 */

export type GetEvnForCustomerSortField =
  (typeof GetEvnForCustomerSortField)[keyof typeof GetEvnForCustomerSortField];

export const GetEvnForCustomerSortField = {
  Datum: "Datum",
  Betrag: "Betrag",
} as const;
